import React from "react";

import "./style.scss";

const BlockBtn = ({
  name,
  handleClick,
  disabled = false,
  type = "primary",
  className = "",
}) => {
  return (
    <button
      type="button"
      className={`block-button-${type} ${
        disabled ? "block-disabled-btn" : ""
      } ${className}`}
      onClick={() => {
        handleClick();
      }}
      disabled={disabled}
    >
      {name}
    </button>
  );
};

export default BlockBtn;
